module.exports = __webpack_public_path__ + "img/logo-MeetingHub-2.d78e3dcc.png";